// user.mapper.ts

import { UserDetailsPartial } from 'src/auth/types';
import { BasketUser } from 'src/api/basketService';
import { UserDataFormValues } from 'src/features/details-form/types';

interface MapperOptions {
    isSpanishTaxApplicable: boolean;
}

const getTaxFields = (values: UserDataFormValues, enabled: boolean) => ({
    nifNumber: enabled ? values.nifNumber ?? null : null,
    nieNumber: enabled ? values.nieNumber ?? null : null,
    passportNumber: enabled ? values.passportNumber ?? null : null,
    passportIssuingCountry: enabled ? values.passportIssuingCountry ?? null : null,
});

export const buildUser = (
    values: UserDataFormValues,
    options: MapperOptions
): UserDetailsPartial => {
    const taxFields = getTaxFields(values, options.isSpanishTaxApplicable);

    return {
        firstName: values.firstName,
        lastName: values.lastName,
        preferredName: values.preferredName,
        email: values.email,
        phone: values.phone,
        dateOfBirth: values.dateOfBirth,
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        postCode: values.postCode,
        country: values.country,
        nationality: values.nationality,
        preferredLanguage: values.preferredLanguage,
        university: values.university,
        studyYear: values.studyYear,
        isSpanishResident: values.isSpanishResident,
        ...taxFields,
        userFormConfirmation: values.userFormConfirmation,
    };
};

export const buildBasketUser = (
    values: UserDataFormValues,
    userId: string | null,
    options: MapperOptions
): BasketUser => {
    const taxFields = getTaxFields(values, options.isSpanishTaxApplicable);

    const dob = `${values.dateOfBirth.year}-${values.dateOfBirth.month?.padStart(2, '0')}-${values.dateOfBirth.day?.padStart(2, '0')}`;
    const phoneNumber = `+${values.phone.callingCode}${values.phone.number}`;

    return {
        id: userId,
        first_name: values.firstName,
        last_name: values.lastName,
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        country: values.country,
        nationality: values.nationality,
        number: phoneNumber,
        phone_code: values.phone.countryCode || '',
        post_code: values.postCode,
        study_year: values.studyYear,
        university: values.university,
        dob,
        email: values.email,
        preferred_language: values.preferredLanguage,
        is_spanish_resident: values.isSpanishResident === 'Yes',
        nif_number: taxFields.nifNumber,
        nie_number: taxFields.nieNumber,
        passport_number: taxFields.passportNumber,
        passport_issuing_country: taxFields.passportIssuingCountry,
    };
};
